"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdvertisementsSlider = void 0;
const react_1 = __importDefault(require("react"));
const swiper_1 = __importStar(require("swiper"));
const react_2 = require("swiper/react");
const Card_1 = require("./Card");
require("swiper/swiper-bundle.css");
require("./index.scss");
swiper_1.default.use([swiper_1.Pagination]);
const className = 'advertisements-slider';
const AdvertisementsSlider = (props) => {
    const { items, delay } = props;
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(react_2.Swiper, { autoplay: { delay: delay !== null && delay !== void 0 ? delay : 2000 }, loop: true, slidesPerView: 1, spaceBetween: 20, pagination: true, navigation: {
                prevEl: `.${className}__prev`,
                nextEl: `.${className}__next`,
            }, autoHeight: true, breakpoints: {
                768: {
                    slidesPerView: 2,
                },
            } }, items.map((item, idx) => (react_1.default.createElement(react_2.SwiperSlide, { key: idx },
            react_1.default.createElement(Card_1.AdvertisementsSliderCard, { className: `${className}__card`, ...item }))))),
        react_1.default.createElement("div", { className: `${className}__prev` }),
        react_1.default.createElement("div", { className: `${className}__next` })));
};
exports.AdvertisementsSlider = AdvertisementsSlider;
//# sourceMappingURL=index.js.map